export const VERIFICATION_STATUS = {
  approved: "approved",
  failed: "failed",
  processing: "processing",
  "approved user send payment 20": "pproved user send payment 20",
};

export const PUBLISH_ACTION_COLOR = {
  activate: "green.400",
  deactivate: "red",
};

export const REPORTABLE_TYPE_COLOR = {
  job: "green.400",
  service: "purple.500",
  invitation: "yellow.500",
  order: "cyan.500",
  professional_profile: "blue.500",
  user: "red.500",
  profile: "pink.500",
};

export const ROLES_STATUS = {
  1: "user",
  2: "admin",
  3: "account",
  4: "super admin",
};
export const PUBLISH_STATUS_COLOR = {
  accept: "green.400",
  pending: "yellow.500",
  PENDING: "yellow.500",
  reject: "red",
};

export const PUBLISHABLE_TYPE_COLOR = {
  job: "green.400",
  service: "purple.500",
  invitation: "yellow.500",
};

export const BANNER_TYPES = {
  root: "root",
  gig: "gig",
};
